import React from "react";

export default function SummaryCard({ icon: Icon, label, value, detail }) {
  return (
    <article className="summary-card">
      <span><Icon size={20} /></span>
      <div>
        <small>{label}</small>
        <strong>{value}</strong>
        <em>{detail}</em>
      </div>
    </article>
  );
}
